// import stringToHTML helper functions
import { stringToHTML } from '../../scripts/stringToHTML.js';

import { Collapse } from 'bootstrap';

// import section style
import './style.scss';

// import search form style
import '../search-modal/style.scss';

// import search modal script
import { searchModalHelper } from '../search-modal/script.js';

// Navbar view helper
export function navbarHelper(navbar) {
  // Handle required navbar template
  var navbar_template;

  if (navbar == 'product')
    navbar_template = require('./navbar-product.html?template').default;
  else if (navbar == 'product support')
    navbar_template = require('./navbar-product_support.html?template').default;
  else if (navbar == 'support')
    navbar_template = require('./navbar-support.html?template').default;
  else if (navbar == 'company')
    navbar_template = require('./navbar-company.html?template').default;
  else if (navbar == 'blog')
    navbar_template = require('./navbar-blog.html?template').default;
  else if (navbar == 'community')
    navbar_template = require('./navbar-community.html?template').default;
  else if (navbar == 'podcast')
    navbar_template = require('./navbar-podcast.html?template').default;
  else navbar_template = require('./navbar.html?template').default;

  const navbar_content = stringToHTML(navbar_template).firstChild;

  // Add navbar to body
  document.body.prepend(navbar_content);

  // Add actions to search modal
  searchModalHelper(navbar_content);

  // Scrolled action
  scrolledHelper(document.querySelector('nav.navbar'));

  // Close mobile menu on mousedown dismiss
  mobileMenuDismiss(document.querySelector('nav.navbar'));

  // Fix modals fixed positioning
  const modals = navbar_content.querySelectorAll('.modal');
  if (modals.length > 0)
    modals.forEach((modal) => {
      // Remove the div from its current position
      modal.parentNode.removeChild(modal);

      // Append the div to the end of the body tag
      document.body.appendChild(modal);
    });
}

// Helper function to active scrolled state
function scrolledHelper(navbar_content) {
  // Scrolled action
  let lastScrollTop = 0;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 100 && window.scrollY < 300) {
      navbar_content.style.setProperty('top', 'var(--scrolled-navbar-from)');
    }
    // Add scrolled class if paged scrolled from beginning to above 300 px.
    else if (window.scrollY > 300) {
      // Set scrolled class to nav bar
      navbar_content.classList.add('scrolled');
      navbar_content.style.setProperty('top', 'var(--z-scrolled-navbar-to)');
    } else {
      // Clear scrolled class from nav bar
      navbar_content.classList.remove('scrolled');
      navbar_content.style.setProperty('top', '');
    }

    // Add scrolled-up class if page scrolled to up
    let scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (navbar_content.classList.contains('scrolled'))
      if (scrollTop > lastScrollTop) {
        navbar_content.style.setProperty('top', 'var(--z-scrolled-navbar-to)');
      } else {
        navbar_content.style.setProperty('top', '');
      }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  });

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function animateTopPosition(element, start, end, duration) {
    const startTime = performance.now();

    function animationFrame(currentTime) {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress = easeOutQuad(progress);

      element.style.top = start + (end - start) * easedProgress + 'px';

      if (progress < 1) {
        requestAnimationFrame(animationFrame);
      }
    }

    requestAnimationFrame(animationFrame);
  }
}

// Helper function to hide mobile menu on mousedown dismiss
function mobileMenuDismiss(navbar_content) {
  document.addEventListener('mousedown', function (event) {
    const menu = navbar_content.querySelector('.navbar-collapse');
    const isClickInsideMenu = menu.contains(event.target);

    if (!isClickInsideMenu) {
      const bsCollapse = new Collapse(menu, { toggle: false });
      bsCollapse.hide();
    }
  });
}
